import Joi from 'joi';
import { TCompanyFieldsFragment, TUserType } from '../../generated/graphql';
import { clearableField } from '../shared/clearableField';

type TGetUserSchemaProps = {
  company?: TCompanyFieldsFragment;
};

export const getUserSchema = (props: TGetUserSchemaProps) => {
  const { company: { emailDomains } = {} } = props;

  const schema = Joi.object()
    .unknown(false)
    .keys({
      name: Joi.string().trim().empty(Joi.valid('', null)).required(),
      email: Joi.string()
        .trim()
        .lowercase()
        .email({
          tlds: {
            allow: false
          }
        })
        .empty(Joi.valid('', null))
        .required()
        .custom((value) => {
          const whitelist = [
            'dan@chocolatesoup.ca',
            'atrujillomateus@gmail.com',
            //'atrujillomateus@hotmail.com',
            //'devcarlosauribe@gmail.com',
            //'yeizermarrugo@gmail.com',
            'cs@chocolatesoup.ca'
          ];
          if (whitelist.includes(value as string)) return value;
          if (!emailDomains?.includes(value.split('@')[1])) throw new Error(`Email from invalid domain. It needs to be one of [${emailDomains?.join(', ')}]`);
          return value;
        }),
      title: clearableField(Joi.string().trim()),
      type: Joi.string()
        .valid(...Object.values(TUserType))
        .required()
    });

  return schema;
};
